import React from 'react';
import {
  FDBodyText, FDTitleText, FDStack, FDIcon, FDPaper,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('content', {
    _component: () => FDBodyText,
  }, overrideReadOnly);

export const Layout = () => {
  const { resource } = useMetaLayoutContext();

  let icon = 'arrowUpFromBracket';
  if (resource.attr('title').includes('join')) {
    icon = 'addPerson';
  }
  if (resource.attr('title').includes('reward')) {
    icon = 'moneyBill';
  }


  return (
    <FDPaper flex={1} padding={2}>
      <FDStack direction="column" spacing={2}>
        <FDIcon icon={icon} />
        <MetaControl attrName={'title'} resource={resource} metaOverrideSet={metaOverrides} />
        <MetaControl attrName={'content'} resource={resource} metaOverrideSet={metaOverrides} />
      </FDStack>
    </FDPaper>
  );
};
